import React, { useState } from 'react';
import { CodeBlock } from './ContainerPageLayout';

/**
 * Shared PHP / C# (and optional Node.js / Python) tabbed code block.
 *
 * Props:
 *   samples: { [key: string]: string }        // { php: "<?php ...", csharp: "[HttpPost]...", ... }
 *   labels?: { [key: string]: string }        // optional prettier labels; defaults below
 *   initial?: string                           // which tab to show first; defaults to the first key in `samples`
 *   testidBase?: string                        // used to namespace data-testids (default "lang")
 */
const DEFAULT_LABELS = {
  php: 'PHP',
  csharp: 'C#',
  nodejs: 'Node.js',
  python: 'Python',
  java: 'Java',
  ruby: 'Ruby',
};

const LangTabs = ({ samples, labels = {}, initial, testidBase = 'lang' }) => {
  const keys = Object.keys(samples);
  const [lang, setLang] = useState(initial || keys[0]);

  return (
    <div data-testid={`${testidBase}-tabs`}>
      <div className="inline-flex rounded-md bg-gray-100 p-1 mb-3" role="tablist">
        {keys.map((k) => (
          <button
            key={k}
            role="tab"
            aria-selected={lang === k}
            onClick={() => setLang(k)}
            className={`px-4 py-1.5 text-xs font-semibold rounded transition-all ${
              lang === k ? 'bg-white text-[#1F4E79] shadow-sm' : 'text-gray-600 hover:text-[#1F4E79]'
            }`}
            data-testid={`${testidBase}-tab-${k}`}
          >
            {labels[k] || DEFAULT_LABELS[k] || k}
          </button>
        ))}
      </div>
      <CodeBlock
        code={samples[lang]}
        lang={lang === 'csharp' ? 'csharp' : lang}
        testid={`${testidBase}-${lang}-code`}
      />
    </div>
  );
};

export default LangTabs;
